/* eslint-disable max-len */
export const lang = {
    "profit allocated to you per month": "سود تخصیص یافته به شما در ماه.",
    "total investment per month": "کل سرمایه گذاری در ماه.",
    "time_out_error_for_apply_change":
        "مدت زمان معتبر برای انجام تغییرات به اتمام رسیده است. لطفا مجددا تلاش کنید.",
    "connection_error_with_bank_network_try_after_min":
        "خطا در ارتباط با شبکه بانکی لطفا دقایقی دیگر مجددا تلاش کنید.",
    "card_added_successful": "افزودن کارت با موفقیت انجام شد",
    "cancel_operation_with_you": "عملیات توسط شما لغو شد",
    "card_updated_successful": "به روزرسانی کارت با موفقیت انجام شد",
    "error_associated_with_banking_server": "خطا در ارتباط با سرویس دهنده بانکی",
    "the_date_entered_for_this_contract_is_incorrect":
        "تاریخ وارد شده برای عقد این قرارداد صحیح نیست",
    "the_desired_tracking_number_was_not_found": "شماره پیگیری مورد نظر یافت نشد",
    "the_values_entered_are_incorrect_Please_try_again":
        "مقادیر وارد شده صحیح نیست. لطفا مجدد اقدام کنید",
    "the_bank_of_your_choice_was_not_found": "بانک مورد نظر شما یافت نشد",
    "the_selected_bank_is_invalid": "بانک انتخاب شده نامعتبر است.",
    "your_user_is_not_allowed_to_perform_this_operation":
        "کاربری شما مجاز به انجام این عملیات نمی باشد",
    "the_logged_in_account_does_not_belong_to_you_lease_define_another_account_number":
        "حساب وارد شده متعلق به شما نمی باشد. لطفا شماره حساب دیگری تعریف کنید",
    "bank_account_with_this_profile_could_not_be_found_redefine_your_bank_account":
        "حساب بانکی با این مشخصات یافت نشد. مجددا نسبت به تعریف حساب بانکی اقدام کنید",
    "emptyTable": "داده ای پیدا نشد!",
    "jibimo": "جیبیمو",
    "pep": "پاسارگاد",
    "daily": "روزانه",
    "weekly": "هفتگی",
    "monthly": "ماهانه",
    "yearly": "سالانه",
    "dd": "حساب های ثبت شده",
    "bt": "ثبت فیش",
    "ipg": "درگاه آنلاین",
    "sms": "پیامک",
    "notify": "پیام",
    "email": "ایمیل",
    "complete": "کامل",
    "incomplete": "ناقص",
    "init": "ایجاد شده",
    "active": "فعال",
    "inactive": "غیرفعال",
    "deleted": "حذف شده",
    "amount": "مقدار",
    "fund_id": "شماره صندوق",
    "fund_name": "صندوق",
    "pod": "پاد",
    "finnotech": "فینوتک",
    "faraboom": "فرابوم",
    "New": "جدید",
    "Home": "خانه",
    "Tasks": "فرایند ها",
    "Notifications": "اعلان ها",
    "Contact List": "همکاران",
    "Delete Department": "حذف دپارتمان",
    "Are you sure you want to delete?": "آیا برای حذف اطمینان دارید؟",
    "Cancel": "بی خیال",
    "Accept": "قبول",
    "Departments": "دپارتمان ها",
    "Title": "عنوان",
    "Description": "توضیحات",
    "Actions": "اقدامات",
    "Save": "ثبت",
    "Create new department": "افزودن دپارتمان جدید",
    "Edit department": "ویرایش دپارتمان",
    "Roles": "نقش ها",
    "Search": "جستجو",
    "Create role": "ایجاد نقش",
    "Edit role": "ویرایش نقش",
    "Name": "نام",
    "Delete Role": "حذف نقش",
    "Submit Filter": "اعمال فیلتر",
    "All": "همه",
    "Select unit": "انتخاب واحد",
    "Search the contact list": "جستجو در لیست مخاطبین",
    "Firstname and lastname": "نام و نام خانوادگی",
    "Local telephone": "تلفن داخلی",
    "Type of cooperation": "نوع همکاری",
    "Unit": "واحد",
    "Phone number": "شماره موبایل",
    "Email": "ایمیل",
    "View contact": "مشاهده مخاطب",
    "Create new notification": "ایجاد اطلاعیه جدید",
    "Notification title": "عنوان اطلاعیه",
    "Notification type": "نوع اطلاعیه",
    "Notification text": "متن اطلاعیه",
    "Send SMS": "ارسال پیامک",
    "Enter your text": "متن خود را وارد کنید",
    "Send notification": "ارسال اطلاعیه",
    "Send to all": "ارسال به همه",
    "Permissions": "مجوز ها",
    "Edit Permission": "ویرایش مجوز",
    "Create Permission": "افزودن مجوز",
    "Delete Permission": "حذف مجوز",
    "CollaborationTypes": "نوع همکاری",
    "Delete Collaboration type": "حذف نوع همکاری",
    "Edit collaboration type": "ویرایش نوع همکاری",
    "Create new collaboration type": "افزودن نوع همکاری جدید",
    "Update": "ویرایش",
    "timespan": "بازه زمانی",
    "Public announcement": "اطلاعیه عمومی",
    "Create new notifications": "ایجاد اطلاعیه جدید",
    "Type of text": "نوع متن",
    "by": "توسط",
    "Announcements": "اطلاعیه ها",
    "date": "تاریخ",
    "View announcements": "مشاهده اطلاعیه",
    "Latest announcments": "اخرین اطلاعیه ها",
    "Date": "تاریخ",
    "List of latest process wait to confirm":
        "لیست آخرین فرآیند های در انتظار تایید",
    "Subject": "موضوع",
    "Process category": "دسته بندی فرآیند",
    "Applicant": "درخواست دهنده",
    "Submit date": "زمان ثبت درخواست",
    "View process": "مشاهده فرآیند",
    "Create new process": "ایجاد فرآیند جدید",
    "Processes": "فرآیندها",
    "Select process": "انتخاب فرآیند",
    "All processes": "همه فرآیندها",
    "Today": "امروز",
    "This week": "هفته اخیر",
    "This month": "ماه اخیر",
    "Process title": "عنوان فرایند",
    "Awaiting my approval": "در انتظار تایید من",
    "Approved by me": "تایید شده توسط من",
    "My requests": "درخواست های من",
    "Announcement": "اطلاعیه",
    "Issued by": "صادر شده توسط",
    "Filter": "فیلتر",
    "Process info": "اطلاعات فرایند",
    "Announcement info": "اطلاعات اطلاعیه",
    "Contact info": "اطلاعات مخاطب",
    "View": "مشاهده",
    "Form": "فرم",
    "Confirm and send": "تایید و ارسال",
    "Process subject": "موضوع فرایند",
    "Expired": "منقضی شده",
    "Active": "فعال",
    "Inactive": "غیرفعال",
    "State": "وضعیت",
    "Version": "نسخه",
    "Create new contact": "همکار جدید",
    "Collaboration type": "نوع همکاری",
    "Lastname": "نام خانوادگی",
    "Password": "رمز عبور",
    "Work Location": "محل کار",
    "Job title": "عنوان شغلی",
    "Mobile": "موبایل",
    "Edit": "ویرایش",
    "Reject the request": "رد درخواست",
    "Please enter the reason for rejecting the request":
        "لطفا دلیل رد درخواست را وارد نمایید",
    "Reject request": "رد درخواست",
    "Send": "ارسال",
    "Submit process modification request": "ارسال درخواست اصلاح فرایند",
    "Please enter the reason for modifying the process":
        "لطفا دلیل اصلاح فرایند را وارد نمایید",
    "Modify request": "نیاز به اصلاح",
    "Yes": "بله",
    "No": "خیر",
    "Steps": "مراحل",
    "Step": "مرحله",
    "Assignee": "منتسب",
    "Completed text": "متن تکمیل شده",
    "Template": "الگو",
    "Edit Step": "ویرایش مرحله",
    "Login to account": "ورود به حساب کاربری",
    "Login to this account": "ورود به حساب کاربر",
    "Enter yout email": "ایمیل خود را وارد کنید",
    "Enter yout password": "رمز خود را وارد کنید",
    "Log in": "ورود",
    "Remember me": "مرا بخاطر بسپار",
    "Forget password": "رمز عبور خود را فراموش کرده‌ام",
    "Not registered yet ?": "هنوز ثبت نام نکرده‌اید؟",
    "Personal information": "اطلاعات فردی",
    "Department": "دپارتمان",
    "Confirm password": "تکرار رمز عبور",
    "Submit information": "ثبت اطلاعات",
    "You have already registered with this email":
        "قبلا با این ایمیل ثبت نام کرده اید",
    "Your email is not registered or you entered your email incorrectly":
        "ایمیل شما در سیستم ثبت نشده است یا ایمیل خود را اشتباه وارد کرده اید",
    "Process reject message from": "پیغام رد فرآیند از طرف",
    "Modify request from": " درخواست اصلاح از طرف ",
    "View process modification request": "مشاهده درخواست اصلاح فرایند",
    "Remove filters": "حذف فیلترها",
    "Notification types": "نوع اطلاعیه",
    "Collaboration types": "نوع همکاری",
    "Positions": "سمت ها",
    "Process": "فرایندها",
    "Security": "امنیت",
    "Position Email": "ایمیل جایگاهی",
    "Check and submit process": "بررسی و ارسال فرآیند",
    "Sending process": "در حال ارسال فرایند",
    "The process was sent successfully": "فرایند با موفقیت ارسال شد",
    "Send process modify request": "ارسال درخواست اصلاح فرآیند",
    "Sending process modification request": "در حال ارسال درخواست اصلاح فرآیند",
    "The modify process was sent successfully":
        "درخواست اصلاح با موفقیت ارسال شد",
    "The reject message was sent successfully":
        "پیغام رد فرآیند با موفقیت انجام شد",
    "Sending process rejection message": "در حال ارسال پیغام در فرآیند",
    "required-error": "فیلد {{field}} الزامی است",
    "Variables": "متغیر ها",
    "Back": "بازگشت",
    "view notification": "مشاهده اطلاعیه",
    "notifications": "اطلاعیه ها",
    "Errors": "خطاها",
    "Close": "بستن",
    "Enter your phone": "شماره موبایل خود را وارد کنید ",
    "Code validity": "اعتبار کد ",
    "seconds": "ثانیه",
    "verify code": "کد تایید ",
    "Enter verify code": "کد تایید را وارد کنید  ",
    "Change phone": "تغییر شماره ",
    "Send code again": "ارسال مجدد کد",
    "Serial national Card": "سریال کارت ملی ",
    "nationalCode": " کد ملی ",
    "FatherName": "نام پدر ",
    "Enter Serial national Card": "سریال پشت کارت ملی را وارد کنید ",
    "Enter nationalCode": "کد ملی را وارد کنید ",
    "Successful registration": "اطلاعات باموفقیت ذخیره شد ",
    "user not found": "کاربر یافت نشد ",
    "Mismatched phone and nationalcode":
        "شماره موبایل وارد شده متعلق به این کد ملی نیست.لطفا نسبت به وارد کردن شماره موبایل صحیح اقدام فرمایید. ",
    "Verification code is either wrong or expired":
        ".کد تأیید یا اشتباه است یا منقضی شده است",
    "not allowed to register":
        "در حال حاضر امکان ثبت نام برای شما فراهم نشده است",
    "The mobile number belongs to someone else":
        "شماره موبایل وارد شده قبلا برای کاربر دیگری ثبت شده است",
    "Complete information": "تکمیل اطلاعات ",
    "Financial": "استعلام ثبت احوال",
    "Sayyah": "افتتاح حساب",
    "Sheba code has been issued": "در حال افتتاح حساب بانکی دیجیتال نکسو",
    "the process of opening a Nexu online account is underway":
        "مراحل افتتاح حساب آنلاین نکسو در حال انجام است. لطفا شکیبا باشید.",
    "Card issuance request": "درخواست صدور کارت مجازی",
    "Card issuance": "صدور کارت ",
    "at the moment not possible issuence card":
        "در حال حاضر امکان صدور کارت وجود ندارد.",
    "card issuance successfully submited ":
        "درخواست صدور کارت با موفقیت انجام شد.",
    "allow request issuance card":
        "حساب بانکی دیجیتال نکسو شما افتتاح شد. در صورت تمایل می‌توانید نسبت به درخواست صدور کارت خود اقدام نمایید.",
    "cardNumber": "شماره کارت",
    "Activation virtualCard": "فعالسازی کارت مجازی ",
    "Enter code for activation card":
        "لطفا برای فعال سازی کارت کد ۷ رقمی که به شماره موبایل شما پیامک شده است  را وارد کنید",
    "CARD_REQUEST_STATUS_ACCEPTED": "کارت بانکی مجازی، صادر شده است.",
    "CARD_REQUEST_STATUS_ACTIVATED": "کارت مجازی فعال شده است. ",
    "CARD_REQUEST_STATUS_WAIT_ACTIVATE":
        "کارت در وضعیت انتظار پیامک فعال سازی است ",
    "CARD_REQUEST_STATUS_DEACTIVATED": "کارت غیرفعال شده",
    "CARD_REQUEST_STATUS_REVOKED": "کارت ابطال شده",
    "CARD_STATUS_BLOCKED": "کارت مسدود شده",
    "PHYSICAL_CARD_STATUS_PRINT_REQUESTED": "درخواست صدور فیزیکی کارت داده شد",
    "PHYSICAL_CARD_REQUEST_STATUS_LOGICALLY_ISSUED":
        "کارت به صورت مجازی صادر شده است",
    "PHYSICAL_CARD_STATUS_PRINTED": "کارت چاپ شده است",
    "PHYSICAL_CARD_STATUS_ACTIVATED": "کارت فیزیکی فعال شده است",
    "PHYSICAL_CARD_STATUS_PRINT_FAILED": "چاپ کارت رد شده است",
    "PHYSICAL_CARD_STATUS_REVOKED": "کارت فیزیکی ابطال شده است",
    "Address": "آدرس",
    "PostalCode": "کدپستی",
    "Enter Address": "آدرس را وارد کنید ",
    "Enter postalCode": "کد پستی را وارد کنید",
    "for print card enter address":
        "جهت چاپ کارت فیزیکی آدرس خود را وارد نمایید",
    "at the moment not possible Activation card":
        "در حاضر امکان فعال سازی کارت وجود ندارد.",
    "at the moment not possible print physical card":
        "در حال حاضر امکان چاپ کارت وجود ندارد .",
    "Activation Card": "فعال سازی کارت ",
    "If you wish, activate the card":
        "در صورت تمایل نسبت به فعال سازی کارت اقدام کنید",
    "Inquiry card status": "استعلام وضعیت کارت",
    "Enter code for direct debit":
        "لطفا برای ثبت درخواست صدور کارت کد پیامک ارسال شده را وارد کنید",
    "at the moment not possible Access direct Debit":
        "در حال حاضر امکان ثبت درخواست صدور کارت وجود ندارد",
    "The last code sent is valid": "آخرین کد ارسالی معتبر است",
    "Inquiry status": "استعلام وضعیت ",
    "Expire Date": "تاریخ انقضا",
    "disabled": "غیرفعال",
    "on-demand": "بر اساس درخواست",
    "ipg_off": "درگاه آنلاین",
    "pt": "واریزی های پوز",
    "sepehr": "سپهر",
    "sep": "سامان",
    "up": "سود دوره ای",
    "Super Admin": "مدیر کل",
    "mst": "تسویه کارمزد",
    "invite_link": "تعداد کل ارسال لینک دعوت",
    "business_card": "تعداد کل ارسال کارت ویزیت",
    "pinvest_registered": "تعداد کل کاربران ثبت نام شده در پینوست",
    "fund_registered": "تعداد کل کاربران ثبت نام شده در صندوق",
    "bt_total_amount": "مقدار کل واریزی از طریق فیش بانکی",
    "ipg_total_amount": "مقدار کل واریزی از طریق درگاه آنلاین",
    "dd_total_amount": "مقدار کل واریزی از طریق حساب های ثبت شده",
    "payment_link": "تعداد کل کاربرانی که لینک پرداخت فعال کرده اند",
    "payment_link_with_pay": "تعداد کل لینک های پرداختی با حداقل یک واریز",
    "pl_total_amount": "مقدار کل واریزی از طریق لینک پرداخت پینوست",
    "sadad": "سداد",
    "vandar": "وندار",
    "ct": "کیف پول نقدی",
    "vt": "هدیه",
};

export default undefined;
